import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const RouteTooltip = ({ deferWallchainStatus }: { deferWallchainStatus: string }) => {
  const { t } = useTranslation()

  return (
    <TooltipBase>
      {deferWallchainStatus === 'found'
        ? t(
            'A Bonus route provided by API is automatically selected for your trade to achieve the best price for your trade.',
          )
        : t(
            'Route is automatically calculated based on your routing preference to achieve the best price for your trade.',
          )}
    </TooltipBase>
  )
}
